// src/frontend/data/books/BlockchainFundamentals/data/cap6.js

const CAP6 = {
  id: 6,
  slug: "cap6-cardano",
  title: "Capítulo 6 — Cardano: la blockchain científica, Ouroboros y gobernanza",
  sections: [
    {
      heading: "¿Qué es Cardano (ADA)?",
      text: [
        "Cardano es una blockchain de tercera generación diseñada con un enfoque académico y científico.",
        "Ha sido construida a partir de investigaciones revisadas por pares, lo que le ha valido el título de la ‘primera blockchain científica’.",
        "Su objetivo principal es ofrecer escalabilidad, seguridad y sostenibilidad a largo plazo."
      ]
    },
    {
      heading: "Una blockchain desarrollada con método científico",
      text: [
        "A diferencia de otros proyectos, Cardano aplica el método científico desde el diseño inicial.",
        "Cada componente del protocolo es investigado, formalizado matemáticamente y revisado por pares.",
        "Esto reduce riesgos estructurales y prioriza la solidez del sistema por encima de la velocidad de lanzamiento."
      ]
    },
    {
      heading: "Origen del proyecto Cardano",
      text: [
        "El desarrollo de Cardano comenzó en 2015 con la creación de IOHK (Input Output Hong Kong).",
        "La empresa fue fundada por Charles Hoskinson y Jeremy Wood.",
        "Hoskinson fue cofundador de Ethereum, pero decidió seguir un camino distinto enfocado en rigor académico.",
        "El primer bloque de Cardano se minó el 23 de septiembre de 2017."
      ]
    },
    {
      heading: "El significado del nombre",
      text: [
        "El nombre Cardano proviene de Girolamo Cardano, matemático italiano pionero en teoría de probabilidades.",
        "El token ADA recibe su nombre de Ada Lovelace, matemática considerada la primera programadora de la historia.",
        "Estos nombres reflejan el enfoque científico y matemático del proyecto."
      ]
    },
    {
      heading: "Cardano como blockchain de tercera generación",
      text: [
        "Cardano está diseñada para transferir valor, ejecutar smart contracts y permitir arquitecturas modulares.",
        "Busca resolver problemas de escalabilidad, interoperabilidad y gobernanza presentes en generaciones anteriores.",
        "Este enfoque la posiciona como una blockchain preparada para el largo plazo."
      ]
    },
    {
      heading: "Ouroboros: el consenso de Cardano",
      text: [
        "Ouroboros es el algoritmo de consenso de Cardano.",
        "Es una variante avanzada de Proof of Stake (PoS) con demostraciones matemáticas formales de seguridad.",
        "Fue el primer protocolo PoS revisado por pares y probado académicamente."
      ]
    },
    {
      heading: "Ouroboros Praos y Ouroboros Hydra",
      text: [
        "Ouroboros Praos es la versión actualmente utilizada en la red.",
        "Introduce mejoras de seguridad frente a ataques adaptativos.",
        "Ouroboros Hydra es la evolución orientada a escalabilidad extrema mediante canales de alta capacidad."
      ]
    },
    {
      heading: "Slots y Epochs",
      text: [
        "Cardano divide el tiempo en slots de aproximadamente 1 segundo.",
        "Los slots se agrupan en epochs que duran alrededor de 5 días.",
        "En cada slot se elige un líder responsable de producir un bloque.",
        "Este diseño reduce reorganizaciones de cadena y forks involuntarios."
      ]
    },
    {
      heading: "Control de forks y finalidad",
      text: [
        "Ouroboros introduce mecanismos de retraso de liquidación.",
        "Solo se considera definitiva una cadena tras un número predefinido de bloques.",
        "Esto mejora la estabilidad del libro mayor y reduce conflictos."
      ]
    },
    {
      heading: "Stake pools: delegación descentralizada",
      text: [
        "Las stake pools permiten que múltiples usuarios deleguen su ADA en un nodo validador.",
        "Funcionan de forma similar a pools de minería, pero sin consumo intensivo de energía.",
        "Este sistema promueve la descentralización sin exigir infraestructura compleja a cada usuario."
      ]
    },
    {
      heading: "Política monetaria de Cardano",
      text: [
        "La emisión máxima de ADA está limitada a 45 mil millones de tokens.",
        "La distribución sigue un modelo deflacionario controlado.",
        "Las recompensas se ajustan dinámicamente según la participación en staking."
      ]
    },
    {
      heading: "Arquitectura por capas: CSL y CCL",
      text: [
        "Cardano se divide en dos capas principales: CSL y CCL.",
        "CSL (Cardano Settlement Layer) gestiona el libro contable y el consenso.",
        "CCL (Cardano Computation Layer) gestiona la lógica de smart contracts y reglas adicionales."
      ]
    },
    {
      heading: "Ventajas de la arquitectura por capas",
      list: [
        "Modularidad y extensibilidad.",
        "Actualizaciones sin afectar el consenso base.",
        "Soporte para múltiples lenguajes y máquinas virtuales.",
        "Mayor facilidad de interoperabilidad."
      ]
    },
    {
      heading: "Smart contracts y Goguen",
      text: [
        "Goguen introduce smart contracts nativos en Cardano.",
        "Utiliza Plutus, un lenguaje basado en Haskell.",
        "Este enfoque prioriza seguridad, verificabilidad y precisión formal."
      ]
    },
    {
      heading: "Basho: escalabilidad e interoperabilidad",
      text: [
        "Basho está enfocada en mejorar el rendimiento de la red.",
        "Introduce sidechains y optimizaciones de red.",
        "Permite escalar sin comprometer seguridad ni descentralización."
      ]
    },
    {
      heading: "Voltaire: gobernanza on-chain",
      text: [
        "Voltaire completa el roadmap de Cardano.",
        "Introduce votaciones on-chain y un tesoro descentralizado.",
        "Permite que la comunidad decida el futuro del protocolo.",
        "Reduce la dependencia de IOHK como entidad central."
      ]
    },
    {
      heading: "ADA: el token nativo",
      text: [
        "ADA es el token nativo de Cardano.",
        "Se utiliza para pagar comisiones, hacer staking y participar en gobernanza.",
        "Es uno de los activos más relevantes del ecosistema cripto."
      ]
    },
    {
      heading: "Estado y proyección a 2025",
      text: [
        "Cardano ha consolidado su infraestructura base.",
        "Continúa expandiendo su ecosistema de dApps, DeFi y gobernanza.",
        "Su enfoque conservador prioriza estabilidad frente a adopción rápida."
      ]
    },
    {
      heading: "Ventajas de Cardano",
      list: [
        "Desarrollo basado en ciencia y revisión por pares.",
        "Alta eficiencia energética.",
        "Arquitectura modular.",
        "Gobernanza descentralizada planificada.",
        "Fuerte comunidad académica y técnica."
      ]
    },
    {
      heading: "Críticas y desafíos",
      text: [
        "Desarrollo más lento que competidores.",
        "Adopción de dApps más gradual.",
        "Complejidad técnica elevada.",
        "Algunas promesas han tomado más tiempo del esperado."
      ]
    },
    {
      heading: "Conclusión",
      text: [
        "Cardano es uno de los proyectos más rigurosos del ecosistema blockchain.",
        "Su enfoque científico la distingue claramente del resto.",
        "Aunque su progreso es más lento, está diseñado para durar décadas.",
        "Comprender Cardano es entender una visión de blockchain pensada para el largo plazo."
      ]
    }
  ]
};

export default CAP6;
